<template>
  <div :class="['leaderboard', 'is-hidden-mobile', { 'top-mar' : topMargin }, { 'bottom-mar' : bottomMargin }]">
    <ins class="leaderboard__ad adsbygoogle leaderboard" data-ad-client="ca-pub-2580109990739065" data-ad-slot="4200499317"></ins>
  </div>
</template>

<script>
  export default {
    props: {
      wait: {
        type: Boolean,
        default: false
      },
      topMargin: {
        type: Boolean,
        default: false
      },
      bottomMargin: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      record: {}
    }),
    mounted () {
      // fetch ad from api
      // if no result, display google - delayed
      // if (!this.wait) {
      setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 500)
      // }
    }
  }
</script>

<style>
  .leaderboard {
    margin: auto;
  }

  .top-mar {
    margin-top: 20px;
  }

  .bottom-mar {
    margin-bottom: 20px;
  }

  .leaderboard__ad {
    display: block;
    width: 100%;
    height: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeaderBoardFluid.vue